<template>
  <b-card
    class="pamm-account-card h-100 mb-0"
    no-body
  >
    <b-card-body class="d-flex flex-column">
      <div class="d-flex align-items-center mb-2">
        <b-avatar
          :text="initials"
          variant="light-primary"
          size="48"
          class="flex-shrink-0"
        />
        <div class="mx-1 overflow-hidden flex-grow-1">
          <h4
            class="mb-25 text-truncate"
            :title="account.nick_name"
          >
            {{ account.nick_name }}
          </h4>
          <small class="text-muted">#{{ account.id }}</small>
        </div>
        <div class="d-flex flex-column align-items-end flex-shrink-0">
          <b-badge
            v-if="hasValue(account.activate)"
            :variant="account.activate ? 'light-success' : 'light-danger'"
            pill
          >
            {{ account.activate ? $t('active') : $t('not_active') }}
          </b-badge>
          <b-badge
            v-if="account.rank > 0"
            variant="light-warning"
            pill
            class="mt-50"
          >
            <feather-icon
              icon="AwardIcon"
              size="12"
            />
            {{ $t('rank') }} {{ account.rank }}
          </b-badge>
        </div>
      </div>

      <b-row
        v-if="stats.length > 0"
        class="pamm-account-card__stats mx-0 mb-2"
      >
        <b-col
          v-for="stat in stats"
          :key="stat.key"
          class="py-1 px-50 text-center"
        >
          <small class="text-muted d-block text-truncate">{{ $t(stat.label) }}</small>
          <span class="font-weight-bolder">{{ stat.value }}</span>
        </b-col>
      </b-row>

      <div class="mt-auto">
        <b-button
          class="pamm-button"
          block
          :to="{ name: 'pamm_management_periods', params: { id: account.id } }"
        >
          <feather-icon
            icon="CalendarIcon"
            size="14"
          />
          <span class="mx-50">{{ $t('pamm_periods') }}</span>
        </b-button>
        <b-button
          variant="outline-primary"
          block
          :to="{ name: 'pamm_management_capital', params: { id: account.id } }"
        >
          <feather-icon
            icon="DollarSignIcon"
            size="14"
          />
          <span class="mx-50">{{ $t('pamm_capital') }}</span>
        </b-button>
        <b-button
          variant="outline-primary"
          block
          :href="`${accountDetailsUrl}/${account.id}`"
          target="_blank"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="14"
          />
          <span class="mx-50">{{ $t('account_page') }}</span>
        </b-button>
        <!-- <b-button
          block
          :to="{ name: 'pamm_management_dashboard', params: { id: account.id } }"
        >
          {{ $t('dashboard') }}
        </b-button> -->
        <!-- <b-button
          block
          :to="{ name: 'pamm_management_trades', params: { id: account.id } }"
        >
          {{ $t('trades') }}
        </b-button> -->
        <!-- <b-button block>
          {{ $t('commisions') }}
        </b-button> -->
        <!-- <b-button
          block
          :to="{ name: 'pamm_management_investors', params: { id: account.id } }"
        >
          {{ $t('investors') }}
        </b-button> -->
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BAvatar,
  BBadge,
} from 'bootstrap-vue'
import { numberWithCommas } from '@/utils/index'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BAvatar,
    BBadge,
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      accountDetailsUrl: process.env.VUE_APP_PAMM_ACCOUNT_BASE_URL,
    }
  },
  computed: {
    initials() {
      const name = (this.account.nick_name || '').trim()
      return name ? name.slice(0, 2).toUpperCase() : '#'
    },
    stats() {
      return [
        { key: 'balance', label: 'balance', unit: '$' },
        { key: 'profit_share_percent', label: 'profit_share', unit: '%' },
        { key: 'fee_percent', label: 'fee_percent', unit: '%' },
      ]
        .filter(stat => this.hasValue(this.account[stat.key]))
        .map(stat => ({ ...stat, value: `${numberWithCommas(this.account[stat.key])} ${stat.unit}` }))
    },
  },
  methods: {
    hasValue(value) {
      return value !== null && value !== undefined && value !== ''
    },
  },
}
</script>

<style lang="scss" scoped>
.pamm-account-card {
  border: 1px solid rgba(34, 41, 47, 0.08);
  box-shadow: none;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    transform: translateY(-2px);
  }

  &__stats {
    border-radius: 0.428rem;
    background-color: rgba(34, 41, 47, 0.03);

    > .col + .col {
      border-left: 1px solid rgba(34, 41, 47, 0.08);
    }
  }
}

.dark-layout .pamm-account-card {
  border-color: #3b4253;

  .pamm-account-card__stats {
    background-color: rgba(255, 255, 255, 0.04);

    > .col + .col {
      border-left-color: #3b4253;
    }
  }
}
</style>
